<template>
  <div class="chart-item">
    <div class="header-border"></div>
    <div class="left-border"></div>
    <div class="right-border"></div>
    <div class="top-border"></div>
    <div class="bottom-border"></div>
    <div class="wrap">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chart-item {
  aspect-ratio: 530/300;
  position: relative;

  .header-border {
    width: calc(100% - 40px);
    height: 3px;
    left: 20px;
    top: 10px;
    background: linear-gradient(90deg, rgba(0, 148, 208, 0.03), rgba(0, 148, 208, 1) 50%, rgba(0, 148, 208, 0.03));
    position: absolute;
  }
  .left-border,
  .right-border {
    width: 1px;
    height: calc(100% - 20px);
    top: 10px;
    background: linear-gradient(rgba(0, 148, 208, 0.1), rgba(0, 148, 208, 1) 50%, rgba(0, 148, 208, 0.1));
    position: absolute;
  }
  .left-border {
    left: 0;
  }
  .right-border {
    right: 0;
  }
  .top-border,
  .bottom-border {
    width: calc(100% - 20px);
    height: 1px;
    left: 10px;
    background: linear-gradient(90deg, rgba(0, 148, 208, 0.1), rgba(0, 148, 208, 1) 50%, rgba(0, 148, 208, 0.1));
    position: absolute;
  }
  .top-border {
    top: 0;
  }
  .bottom-border {
    bottom: 0;
  }
  .wrap {
    position: absolute;
    left: 15px;
    top: 25px;
    width: calc(100% - 30px);
    height: calc(100% - 40px);
    color: #fff;
  }
}
</style>
